import { uuidv7 } from 'uuidv7';

/** All primary keys are application-generated, time-ordered UUIDv7 values. */
export const newId = (): string => uuidv7();

export const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Custom-field keys are immutable identifiers used inside `ticket.fields` JSONB,
 * saved views and automation rules. Renaming a field never changes its key.
 */
export const FIELD_KEY_PREFIX = 'cf_';
export const FIELD_KEY_PATTERN = /^cf_[0-9a-z]{8}$/;

const BASE36 = '0123456789abcdefghijklmnopqrstuvwxyz';

/** Generates a key such as `cf_7k2m9qx1` using the platform CSPRNG (Node 19+ and browsers). */
export function newFieldKey(): string {
  const bytes = new Uint8Array(8);
  globalThis.crypto.getRandomValues(bytes);
  let out = FIELD_KEY_PREFIX;
  for (const b of bytes) {
    out += BASE36[b % 36];
  }
  return out;
}

export const isFieldKey = (value: string): boolean => FIELD_KEY_PATTERN.test(value);
